import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController } from 'ionic-angular';

import { globalDefines } from '../../app/app.constants';
import { CheckHour } from '../../models/check-hour';
import { Timetable } from '../../models/timetable';
import { TimetableProvider } from '../../providers/timetable/timetable';

@IonicPage()
@Component({
  selector: 'page-timetable-info',
  templateUrl: 'timetable-info.html',
})
export class TimetableInfoPage {

  checks;
  hour;
  mode;
  selectedType;
  timetable = {} as Timetable;
  title: string;  

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public timetableProvider: TimetableProvider,
  ) {
    this.mode = this.navParams.get('mode')
    this.initMode();
  }

  addCheck() {
    if(this.hour && this.selectedType) {
      if(!this.timetable.checks) this.timetable.checks = []
      
      this.timetable.checks.push({ 'hour': this.hour, 'type': this.selectedType } as CheckHour);

      this.hour = null;
      this.selectedType = null;
    }
    
    else this.showMessage(`Introduzca una hora y un tipo de fichaje.`);
  }

  initMode() {
    switch(this.mode) {
      case 'info': { 
        this.title = 'Información'; 
        this.timetable = this.navParams.get('timetable');
        break
      };

      case 'edit': { 
        this.title = 'Editar'; 
        this.timetable = this.navParams.get('timetable');
        break 
      };

      case 'add': { 
        this.title = 'Añadir'; 
        break
      };
    }
  }

  removeCheck(check) {
    this.timetable.checks.splice(check, 1);
  }

  save() {
    if(this.timetable.name && this.timetable.hours) {
      this.timetableProvider.save(this.timetable).then(() => {
        this.navCtrl.pop();
      });
    }
    else this.showMessage(`Introduzca todos los datos.`);
  }

  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/timetable-info/timetable-info.ts